import React from 'react';
import { connect, Provider } from "react-redux"
import Vimeo from '@u-wave/react-vimeo';

import Swiper from 'react-id-swiper';
import Quill from 'quill';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
import ReactHtmlParser from 'react-html-parser';
// import { convertHtmlToDelta } from 'node-quill-converter';

import { setModal, fetchPracticeById } from "../../actions/index";
import { getGalleryItemsForPatient, deleteGallery, deleteGalleryVideo } from '../../actions/gallery'
import SelectTherapyCategories  from '../admin/SelectTherapyCategories'
import FileUpload from '../ui/FileUpload'
import MultiFileUpload from '../ui/MultiFileUpload'
import { deleteImage } from '../../actions/images'
import Video from '../video/FullScreenVideo'
import TextareaAutosize from 'react-autosize-textarea';
import DocumentUpload from '../ui/DocumentUpload'

import SelectVideos from '../video/SelectVideos'
import SelectVideosNew from '../video/SelectVideosNew'
import closeImage from '../../images/icons/close_black.svg';
import moment from 'moment'
import filter from 'lodash/filter'
import spinner from './images/spinner.svg'
import spinnerGif from './images/spinnerGif.gif'

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import SearchIcon from '../../images/icons/SearchIcon';
import backArrowSvg from './images/arrow-right.svg';
import savedSVG from './images/saved.svg';
import trashRedSVG from './images/trashRed.svg';

import { fetchPractice } from "../../actions/index";

import eventbus from '../../store/eventbus'

// GLOBAL MEDIA UPLOAD
import { openCloseMediaUpload, setCurrentSessionInStore, setIsInternalUpload, setSessionName, setScopeAndSessionType, setCurrentPatientInSessionObj } from '../../actions/media_upload'

@connect((store) => {
  return {
    practice_types: [...store.practice_types],
    User: store.User.User,
    therapy_areas: store.therapy_areas,
    therapy_categories: store.therapy_categories,
    media_upload: store.media_upload,
    gallery: store.gallery
  }
})
class NewSession extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'selectTherapyAreasOpen': false,
      'selectVideosOpen': false,
      'playingVideo': null,
      'uploadedImages': {},
      'startSessionDate': moment(),
      'search': '',
      'internalNotesTickedAreas': [],
      'internal': 'active',
      'internalDisabled': false,
      'parent': '',
      'parentDisabled': false,
      'sessionSaved': false,
      'notesArray': [],
      'internalNote': '',
      'internalNote': [],
      'backLoad' : false,
      'html':''
    };
    this.getNewSessionDate = this.getNewSessionDate.bind(this)
    this.toggle = this.toggle.bind(this)
    this.toggleSelectTherapyAreasOpen = this.toggleSelectTherapyAreasOpen.bind(this)
    this.toggleSelectVideosOpen = this.toggleSelectVideosOpen.bind(this)
    this.playVideo = this.playVideo.bind(this)
    this.closeVideo = this.closeVideo.bind(this)
    this.attachImage = this.attachImage.bind(this)
    this.deleteImage = this.deleteImage.bind(this)
    this.attachInternalImage = this.attachInternalImage.bind(this)
    this.deleteInternalImage = this.deleteInternalImage.bind(this)
    this.handleSessionDateChange = this.handleSessionDateChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.videos = this.videos.bind(this)
    this.noteTaking = this.noteTaking.bind(this)
    this.toggleActivePanel = this.toggleActivePanel.bind(this)
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.backButton = this.backButton.bind(this)
    this.swiper = null
    this.addNote = this.addNote.bind(this)
    this.editNote = this.editNote.bind(this)
    this.deleteNote = this.deleteNote.bind(this)
    this.footerBackButton = this.footerBackButton.bind(this)
    this.nextButton = this.nextButton.bind(this)
    this.saveAndClose = this.saveAndClose.bind(this)
    this.findCatByID = this.findCatByID.bind(this)
    this.saveAsDraft = this.saveAsDraft.bind(this)
    this.createQuill = this.createQuill.bind(this)
    this.toggleDisableInternalBtn = this.toggleDisableInternalBtn.bind(this)
    this.toggleDisableParentBtn = this.toggleDisableParentBtn.bind(this)
    this.headerBtns = this.headerBtns.bind(this);
    this.toggleMediaUpload = this.toggleMediaUpload.bind(this)
    this.loadGallery = this.loadGallery.bind(this)
    this.loadGalleryNoteTemplate = this.loadGalleryNoteTemplate.bind(this)
    this.photoNoteTemplate = this.photoNoteTemplate.bind(this)
    this.documentNoteTemplate = this.documentNoteTemplate.bind(this)
    this.videoNoteTemplate = this.videoNoteTemplate.bind(this)
    this.deleteGalleryMedia = this.deleteGalleryMedia.bind(this)
  }

  componentDidMount() {
    this.noteTaking();
    this.createQuill();
    // this.props.dispatch(fetchPractices());
    //Close and save new session on back button press
    window.history.pushState(null, 'NewSession', window.location.href + '#newSession')
    window.addEventListener('popstate', this.saveAsDraft);

    if (this.props.session && this.props.session.practice) {
      this.props.dispatch(fetchPracticeById(this.props.session.practice))
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.saveAsDraft);
  }

  getNewSessionDate(session) {
    if (session.created) {
      return moment(session.created);
    }
    var dateCreated = moment();
    this.handleSessionDateChange(dateCreated);
    return dateCreated;
  }

  backButton() {
    console.log('Back Button');
    this.props.saveSession(false, false);
    this.props.close();
  }

  toggleMediaUpload(bool){
    if(bool){
      // this.props.saveSession(false, false)
      setIsInternalUpload(this.state.internal == "active" ? true : false)
      setSessionName(`session_${new Date().getTime()}`)
      setCurrentSessionInStore(this.props.session)
      setCurrentPatientInSessionObj(this.props.patient.id)

      if(this.state.internal == "active"){
        setScopeAndSessionType({scope: "internal", sessionType: "note", parent: false, therapist: true})
      } else {
        setScopeAndSessionType({scope: "public", sessionType: "note", parent: false, therapist: true})
      }
    }
    openCloseMediaUpload(bool)
    console.log("Session in media_upload", this.props.media_upload.session)
  }

  createQuill(){
    var el = document.querySelectorAll('#editor-container')[0];
    var quill = new Quill(el, {
      modules: {
        toolbar: [
          //[{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline'],
          [{ 'list': 'bullet' }],
          [{ 'background': [false,'yellow'] }]
        ]
      },
      // placeholder: 'Compose an epic...',
      // value: this.props.session.internal_notes,
      theme: 'snow'  // or 'bubble'
    });

    // quill.setContents(convertHtmlToDelta(this.props.session.internal_notes));
    
    if (this.props.session.internal_notes != '') {
      quill.clipboard.dangerouslyPasteHTML(this.props.session.internal_notes);
    }

    let that = this;
    quill.on('editor-change', function(eventName, ...args) {
      if (eventName === 'text-change') {
        // console.log(quill.getContents())
        // this.setState({internalNote: quill.getContent()})
        var delta = quill.getContents();
        // console.log('delta ops', delta.ops)
        var cfg = {};
        var ops = delta.ops;
        var converter = new QuillDeltaToHtmlConverter(ops, cfg);

        var htm = converter.convert();
        that.setState({ html:htm });
        that.props.session.internal_notes = htm;
        // console.log(html)
      } else if (eventName === 'selection-change') {
        // args[0] will be old range
      }
    });
    return quill;
  }

  handleSessionDateChange(date) {
    this.props.session.created = date;
    this.setState({
      startSessionDate: date
    });
  }

  toggle(key, val) {
    this.setState({
      [key]: typeof val === 'undefined' ? !this.state[key] : val
    })
  }

  closeVideo() {
    this.playVideo(false)
  }

  playVideo(video) {
    this.setState({
      playingVideo: video
    })
  }

  attachImage(img) {
    let { uploadedImages, internalDisabled } = this.state;
    this.setState({
      'uploadedImages': { ...uploadedImages, [img.orig]: img.orig }
    })
    this.props.attachImage(img)
    if (internalDisabled) {
      this.toggleDisableInternalBtn();
    }
  }

  attachInternalImage(img) {
    let { uploadedImages, parentDisabled } = this.state;
    this.setState({
      'uploadedImages': { ...uploadedImages, [img.orig]: img.orig }
    })
    this.props.attachInternalImage(img)
    if (parentDisabled) {
      this.toggleDisableParentBtn();
    }
  }

  deleteImage(img) {
    let { uploadedImages } = this.state;
    if (confirm('Really delete this image?')) {
      deleteImage(img);
      this.props.removeImage(img);
      this.setState({
        'uploadedImages': { ...uploadedImages, [img.orig]: null }
      })
    }
  }

  deleteInternalImage(img) {
    let { uploadedImages } = this.state;
    if (confirm('Really delete this image?')) {
      deleteImage(img);
      this.props.removeInternalImage(img);
      this.setState({
        'uploadedImages': { ...uploadedImages, [img.orig]: null }
      })
    }
  }

  toggleSelectTherapyAreasOpen() {
    this.toggle("selectTherapyAreasOpen")
    
  }

  toggleSelectVideosOpen() {
    this.toggle("selectVideosOpen")
    
  }

  onSearchChange(e) {
    this.setState({
      'search': e.target.value
    })
    
  }

  videos() {
    const { videos } = this.props;
    const { search } = this.state;

    const searchExp = new RegExp(search, 'iy')
    let filterArrayVideos = Object.values(videos).filter(v => v.name.match(searchExp));

    let filterVideos = new Object();
    filterArrayVideos.forEach(element => {
      filterVideos[element._id] = element;
    });

    // console.log(filterVideos);
    return filterVideos;
  }

  swiperHeight() {
    
  }

  noteTaking(e) {
    const { therapy_areas, therapy_categories, selected_areas, session, practice_types } = this.props;
    let val = session.internal_notes + session.parent_notes;
    let selectedByNote = this.state.internalNotesTickedAreas;
    let searchExp = '';
    let practiceType = practice_types.find(({_id}) => _id === this.props.app.practice.practice_type);
    // console.log(practiceType);
    // console.log(therapy_areas);
    // console.log(therapy_categories);
    var filterArrayCategories = [];
    for (let key in therapy_categories) {
      if (therapy_categories.hasOwnProperty(key)) {
        if (therapy_categories[key].practice_type === practiceType.id) {
          filterArrayCategories.push(therapy_categories[key].id);
        }
      }
    }
    // console.log(filterArrayCategories);

    if (selectedByNote.length > 0) {
      selectedByNote.forEach(a => {
        if (selected_areas.length > 0) {
          selected_areas.forEach(area => {
            setTimeout(() => {
              if (area._id === a._id) {
                console.log('Remove Area');
                this.props.assignSessionTherapyArea(area);
              }
            }, 1000)
          });
        }
      });
      selectedByNote = [];
    }

    if (val !== '') {
      for (let key in therapy_areas) {
        if (therapy_areas.hasOwnProperty(key)) {
          if (filterArrayCategories.some(item => therapy_areas[key].categories.includes(item))) {
            let searchString = therapy_areas[key].name;
            searchString = searchString.replace(/\s*$/, "");
            searchString = searchString.replace('(', '\\(');
            searchString = searchString.replace(')', '\\)');
            searchExp = new RegExp("(" + searchString + ")", 'i');
            if (val.match(searchExp)) {
              console.log('Found');
              setTimeout(() => {
                this.props.assignSessionTherapyArea(therapy_areas[key]);
                selectedByNote.push(therapy_areas[key]);
                // console.log(selectedByNote);
              }, 1000);
            } else {
              console.log('Not Found');
            }
          }
        }
      }
    }
    this.setState({
      internalNotesTickedAreas: selectedByNote
    });
  }

  toggleActivePanel(panel){
    if (panel === 'internal') {
      this.setState({
        internal: 'active',
        parent: '',
      });
      setTimeout(
        () => {
          let quill = this.createQuill();
          document.querySelectorAll('.ql-toolbar')[1].remove();
          quill.clipboard.dangerouslyPasteHTML(this.props.session.internal_notes);
        },
        100)
    } else {
      this.setState({
        parent: 'active',
        internal: '',
      })
    }
  }

  goNext() {
    //on clicking next button data is saved
    this.props.saveSession(false, false)
    this.setState({ sessionSaved : true })
    if (this.swiper) this.swiper.slideNext()

    //Scroll slide to top on next slide
    const swiperContainer = document.querySelector('.modal-content');
    swiperContainer.scrollTop = 0
  }
 
  goPrev() {
    //on clicking prev button data is saved
    this.props.saveSession(false, false)
    this.setState({ sessionSaved : true })
    if (this.swiper) this.swiper.slidePrev()
  }

  addNote() {
    if (this.props.session.internal_notes_array === undefined) {
      this.props.session.internal_notes_array = []
    }

    // if (this.props.session.internal_notes_array.length < 1) {
    //   this.props.session.internal_notes_array.push(this.props.session.internal_notes)
    //   // this.props.session.internal_notes = ''
    //   this.toggleActivePanel('internal')
    // }

    this.props.saveSession(false, false)
    this.setState({ sessionSaved : true })
    this.setState({ backLoad : true })
    setTimeout(()=> this.setState({ backLoad : false }), 5000)
  }

  deleteNote(index){
    if (window.confirm('Are you sure you wish to delete this item?')) {
      this.props.session.internal_notes_array.splice(index, 1)
    }
    this.toggleActivePanel('internal')
  }

  editNote(index){
    let internalNote = this.props.session.internal_notes;
    
    if (internalNote === '') {
      this.props.session.internal_notes = this.props.session.internal_notes_array[index];
      this.props.session.internal_notes_array.splice(index, 1)
    } else {
      // this.props.session.internal_notes  = '';
    }
    this.toggleActivePanel('internal')
  }

  saveAndClose() {
      this.props.saveSession(true)
      this.props.close()
  }

  footerBackButton() {
    let { playingVideo } = this.state;
    const begin = (this.swiper === null || this.swiper.isBeginning) ? true:false;
    
    if (playingVideo) {
      this.closeVideo();
    } else {
      if (begin) {
        this.backButton();
      } else {
        this.goPrev();
      }
    }
  }

  nextButton(){
    let btn = '';
    let begin = false

    if (this.swiper === null || this.swiper.isBeginning) {
      begin = true
    } else {
      begin = false
    }

    if (this.swiper !== null && this.swiper.isEnd ) {
      // console.log(this.props.session.videos);
      btn = <a onClick={() => this.saveAndClose()} className="">Send</a>

    } 
    if (this.swiper !== null && !this.swiper.isEnd ) {
      
      btn = <a onClick={this.goNext} className="">Next: Exercises</a>

    } 
    if (begin) {

      btn = <a onClick={this.goNext} className="">Next: Therapy Areas</a>

    }

    return btn;
  }

  findAreaByID(areas, id) {
    // console.log(id)
    // console.log(areas)
    let selected = []

    let area = []
    if (id.length !== 0){
      id.forEach(i => {
        area.push(_.filter(areas, ['_id', i]))
      })

      area.forEach(a => {
       selected.push(a[0].name)
      })
    }

    return selected;
  }

  findCatByID(categories, selected_categories, selected) {
    //use selected to find cat id from selected_categories then use that to find name from categories
    // console.log('cats',categories)
    // console.log('sel cats', selected_categories)
    // console.log('selected',selected)

    let newSelCat = []
    let newCategories = []
    let returnCategories = []

    if (selected.length !== 0) {
      selected.forEach(select => {
        newSelCat.push(_.filter(selected_categories, ['_id', select]))
      })

      newSelCat.forEach(cat => {
        cat.forEach(newCat => {
          // console.log(newCat)
          newCategories.push(_.filter(categories, ['_id', newCat.categories[0]]))
        })
      })

      newCategories.forEach(cat => {
        cat.forEach(cate => {
          returnCategories.push(cate.name)
        })
      })
    }
    
    return _.uniq(returnCategories)
  }

  saveAsDraft() {
    this.props.saveSession(false)
    this.props.close()
  }

  toggleDisableInternalBtn() {
    this.toggle("internalDisabled");
  }

  toggleDisableParentBtn() {
    this.toggle("parentDisabled");
  }

  headerBtns() {
    return (
      <div className="headerBtns">
        {/* add active class below to wichever is active */}
          <button onClick={(e) => this.toggleActivePanel('internal')} className={this.state.internal} disabled={this.state.internalDisabled}>Internal</button>
          <button onClick={(e) => this.toggleActivePanel('parent')} className={this.state.parent} disabled={this.state.parentDisabled}>Public</button>
      </div>
    );
  }

  loadGallery(galleryIds, type) {
    const { gallery } = this.props;

    let documents = [];
    let photos = [];
    let videos = [];
    let formatedGallery = [];

    if (galleryIds.length > 0 && gallery.items.length > 0) {
      galleryIds.forEach(galId => {
        let galIndex = gallery.items.findIndex((gal) => gal.id == galId);
        
        if (galIndex > -1 && type == gallery.items[galIndex].scope) {
          switch (gallery.items[galIndex].media) {
            case 'photo':
              photos.push(galId);
              break;
      
            case 'document':
              documents.push(galId);
              break;
      
            case 'video':
              videos.push(galId);
              break;
          
            default:
              break;
          }
        }
      });
      // console.log(documents);
      // console.log(photos);
      // console.log(videos);
      formatedGallery = documents.concat(photos);
      formatedGallery = formatedGallery.concat(videos);

      return formatedGallery.map(gal => (this.loadGalleryNoteTemplate(gal, type)));
    }
    return '';
  }

  loadGalleryNoteTemplate(galId, type) {
    const { gallery } = this.props;
    // console.log(galId);
    if (gallery.items.length) {
      let galIndex = gallery.items.findIndex((gal) => gal.id == galId);
      // console.log(gallery.items[galIndex]);
      if (galIndex > -1 && type == gallery.items[galIndex].scope) {
        switch (gallery.items[galIndex].media) {
          case 'photo':
            return this.photoNoteTemplate(gallery.items[galIndex]);
            break;
    
          case 'document':
            return this.documentNoteTemplate(gallery.items[galIndex]);
            break;
    
          case 'video':
            if (gallery.items[galIndex].url !== undefined &&
              gallery.items[galIndex].url !== 'Uploading Video' &&
              gallery.items[galIndex].url !== 'Failed to upload Video'
            ) {
              return this.videoNoteTemplate(gallery.items[galIndex]);
            }
            break;
        
          default:
            break;
        }
      }
    }
    return '';
  }

  photoNoteTemplate(gal) {
		return <div className="thumb photo" key={gal.id}>
			<img src={gal.url}/>
      <a className="link" onClick={() => {
          this.deleteGalleryMedia(gal)
      }} ><img src={trashRedSVG} alt="Delete"/></a>
		</div>
	}

	documentNoteTemplate(gal) {
		return <div className="thumb file" key={gal.id}>
			<a href={gal.url} target="_blank" className="fileName">
			<svg fill="#c11515"  aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-pdf" className="svg-inline--fa fa-file-pdf fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#c11515" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"></path></svg>
				<span>
					{gal.filename ? gal.filename : "File"}
					<small>PDF Document</small>
				</span>
			</a>
      <a className="link" onClick={() => {
        this.deleteGalleryMedia(gal)
      }} ><img src={trashRedSVG} alt="Delete"/></a>
		</div>
	}

	videoNoteTemplate(gal) {
		return <div className="thumb video" key={gal.id}>
			<Vimeo
				responsive={true}
				video={gal.url.replace("/videos/", "")}
			/>
      <a className="link" onClick={() => {
        this.deleteGalleryMedia(gal)
      }} ><img src={trashRedSVG} alt="Delete"/></a>
		</div>
  }
  
  deleteGalleryMedia(gal) {
    if (gal.id !== undefined && gal.media !== undefined) {
      switch (gal.media) {
        case 'photo':
        case 'document':
          // Delete from firebase
          // Delete from gallery
          this.props.dispatch(deleteGallery(gal.id));
          break;

        case 'video':
          // Delete from gallery video
          this.props.dispatch(deleteGalleryVideo(gal.id));
          break;
        
        default:
          break;
      }
      this.props.dispatch(getGalleryItemsForPatient(this.props.patient.id));
      eventbus.publish("removeGalleryIdInSession", gal);
    }
  }

  render() {
    const { User, therapy_areas, selected_areas, patient, session, close, therapy_categories } = this.props
    if (session.parent_notes === undefined || session.parent_notes === '' ) {
      session.parent_notes = ''
    }

    if (session.internal_notes === undefined || session.internal_notes === '' ) {
      session.internal_notes = ''
    }

    const swiperParams = {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      spaceBetween: 10,
      observer: true,
      observeParents: true,
      noSwiping: true,
      noSwipingClass: 'swiper-slide'
    }

    return <div className="backgroundCover"><div id="sessionModal" className="modal-fill sessionModal scroll">
      <div className="modal-header">
       <div className="close link" onClick={ !this.state.backLoad ? () => this.backButton() : '' }><img src={ this.state.backLoad ? spinner : backArrowSvg }   alt={ this.state.backLoad ? 'loading' : 'back arrow' }/>
       </div>
        <div className="modal-title fill">
          <b>{patient.firstName} {patient.lastName} - New Session</b>
        </div>
        <div className={ this.state.sessionSaved ? 'savedIcon saved' : 'savedIcon' } >
            {/* toggle the saved class above to show and hide */}
            <img src={savedSVG} alt="save icon"/>
            <span>SAVED</span>
        </div>
      </div>
      
      <div className="modal-content">
      <Swiper {...swiperParams} ref={node => this.swiper = node !== null ? node.swiper : null }>
      <div className="swiper-slide  swipePage1">
        <div className="datePicker">
          <label>Date <br className="desktopNone"/>& Time</label>
          {/* <input className="md-input md-title hide"
            autoComplete="off"
            onChange={(e) => this.props.handleSessionFormChange(e, 'created')}
            value={moment(session.created).format('YYYY-MM-DD HH:mm')}
            type="date" placeholder="yyy/mm/dd - hh:mm" style={
              {
                'borderBottom': 'none'
              }
            } /> */}
          <DatePicker
            popperPlacement="bottom-end"
            selected={this.getNewSessionDate(session)}
            onChange={this.handleSessionDateChange}
            onChangeRaw={(date) => {
              if (moment(date.target.value).isValid())
                    {this.handleSessionDateChange(moment(date.target.value))}
            }}
            showTimeSelect
            timeIntervals={30}
            dateFormat="YYYY/MM/DD HH:mm"
            showYearDropdown
            popperModifiers={{
              flip: {
                  behavior: ["bottom"] 
              },
              preventOverflow: {
                  enabled: false 
              },
              hide: {
                  enabled: false 
              }
            }}
          />
        </div>
        
        <div className={this.state.internal ? "internalAndParentNotes" : "internalAndParentNotes hideToolbar"}>
            <div className="headerButtons">
                <div>
                  Notes
                  {this.state.internal ? <small>Visible only to you</small> : ''}
                </div>
                {this.headerBtns()}
            </div>

            { this.state.internal &&
              <div 
                id="editor-container"
                style={{'height': '325px'}}
                onChange={(e) => this.props.handleSessionFormChange(e, 'internal_notes')}
                onBlur={(e) => this.noteTaking(e)}
                >
              </div> }
            { !this.state.internal &&
              <TextareaAutosize className="md-body-1 inputTextArea"
                value={session.parent_notes}
                placeholder={'Enter your parent notes here...'}
                onChange={(e) => this.props.handleSessionFormChange(e, 'parent_notes')}
                onBlur={(e) => this.noteTaking(e)}
              /> }

          <div className="grid gallery">
          { this.state.internal ?
            session.gallery && (
              this.loadGallery(session.gallery, 'internal')
            )
            :
            session.gallery && (
              this.loadGallery(session.gallery, 'public')
            )
          }
          </div>
          <div className="grid gallery">
          { this.state.internal ?
            session.internal_images && (
              session.internal_images.map(img => (<div className="image-container" key={img.orig}>
                  <img role="presentation"
                    src={img.orig || img.thumb} />
                  <a className="link" onClick={() => {
                    this.deleteInternalImage(img)
                  }} ><img src={trashRedSVG} alt="Delete"/></a>
                </div>))
            )
            :
            session.images && (
              session.images.map(img => (
                <div className="image-container" key={img.orig}>
                  <img role="presentation"
                    src={img.orig || img.thumb} />
                  <a className="link" onClick={() => {
                    this.deleteImage(img)
                  }} ><img src={trashRedSVG} alt="Delete"/></a>
                </div>))
            )
          }
          </div>
          <div className="addImage">
            <div className="multiUpload">
              <div onClick={(e)=> this.toggleMediaUpload(true)}>
                <span><svg width="25" aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus-square" className="svg-inline--fa fa-plus-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path></svg></span> Add Attachments
              </div>
            </div>
            <hr/>
              <div className="ctaSave">
                <button onClick={ this.addNote } >SAVE NOTE</button>
              </div>
          </div>

        </div>

        <div className="notesAdded">
          {/*Notes Added
          {session.internal_notes_array !== undefined && session.internal_notes_array.length > 0 ?
            session.internal_notes_array.map((note, index) =>
              <div className="notesBox" key={`note-box-${index}`}>
                <div>
                  <span>Internal</span>
                  <a onClick={() => this.deleteNote(index)}><img src={trashSVG} alt="Delete"/></a>
                  <a onClick={() => this.editNote(index)}><img src={penSVG} alt="Edit"/></a>
                </div>
                <p>{ note }</p>
                <div>
                {session.internal_images && (
                  session.internal_images.map(img => (
                    <div className="image-container" key={img.thumb}>
                      <img role="presentation"
                        src={this.state.uploadedImages[img.orig] || img.thumb} />
                      <a className="link" onClick={() => {
                        this.deleteInternalImage(img)
                      }} ><img src={trashRedSVG} alt="Delete"/></a>
                    </div>))
                )
                }
                </div>
              </div> )
          : ''}


          {session.parent_notes !== undefined && session.parent_notes.length > 0 ?
          <div className="notesBox">
            <div>
              <span>Parent</span>
              <img src={trashSVG} alt="Delete"/>
              <img src={penSVG} alt="Edit"/>
            </div>
            <p>{ session.parent_notes }</p>
            <div>
              {session.internal_images && (
                session.internal_images.map(img => (
                  <div className="image-container" key={img.thumb}>
                    <img role="presentation"
                      src={this.state.uploadedImages[img.orig] || img.thumb} />
                    <a className="link" onClick={() => {
                      this.deleteInternalImage(img)
                    }} ><img src={trashRedSVG} alt="Delete"/></a>
                  </div>))
              )
              }
            </div>
          </div> : ''} */}
        </div>
      </div> 
        {/* end first slide */}


        {/* start second slider */}
      <div className="swiper-slide swiperPage2">
            <div className="notesDate">
              <div>
                <p><strong>Date:</strong> {moment(session.created).format('YYYY-MM-DD HH:mm')}</p>
                <p><strong>Notes:</strong> { session.internal_notes !== undefined ? 1 : 0 } Internal - { session.parent_notes !== undefined && session.parent_notes.length ? 1 : 0 } Parent</p>
                <p><strong>Images:</strong> { session.internal_images !== undefined ? session.internal_images.length : 0 } Internal - { session.images !== undefined ? session.images.length : 0 } Parent</p>
              </div>
            </div>
        <div>
          <h6 className="">
            Therapy Areas
          </h6>
          {/*<div className="search-box__content">
            <div className="search-box__input">
                <SearchIcon />
                <input type="search" onChange={this.onSearchChange} value={this.state.search} placeholder="Search for an excersize or area..." />
            </div>
          </div>*/}
            
            <div className="selectedAreasContainer">
              <b>Selected Areas:</b>
                <div>
                {
                  selected_areas.map((area => (<span key={`new-session-area-${area._id}`}>
                    {area.name} </span>)))
                }
                {selected_areas.length === 0 && <span>No therapy areas selected</span>}
                </div>
            </div>
        </div>
          <div>
            <SelectTherapyCategories
                click={this.props.assignSessionTherapyArea}
                checkedCond={area => {
                  return session.therapy_areas.indexOf(area._id) !== -1
                  }
                } 
              therapy_areas={therapy_areas} />
          </div>
          {/* <DocumentUpload  /> */}
      </div>
        {/* end of slide two */}
        
        {/* start slide three */}
        <div className="swipePage3">
      
          <div className="notesDate">
            <div>
              <p><strong>Date:</strong> {moment(session.created).format('YYYY-MM-DD HH:mm')}</p>
              <p><strong>Notes:</strong> { session.internal_notes !== undefined ? 1 : 0 } Internal - { session.parent_notes !== undefined && session.parent_notes.length ? 1: 0 } Parent</p>
              <p><strong>Images:</strong> { session.internal_images !== undefined ? session.internal_images.length : 0 } Internal - { session.images !== undefined ? session.images.length : 0 } Parent</p>
            </div>
            <div>
              <p><strong>Areas:</strong></p>
              {
                this.findCatByID(therapy_categories, therapy_areas, session.therapy_areas).map(((category, key) => (
                  <p key={`categories-${key}`}> {category} </p>)))
              }
              {/*
                  selected_areas.map((area => (<p key={`new-session-area-${area._id}`}>
                   {area.name}
                    </p>)))
                */}
            </div>
          </div>
          <h6>Exercises</h6>
          <div>
            <div className="selectedContainer">
            <b>Selected Exercises:</b>
                { 
                  this.findAreaByID(this.props.videos, this.props.session.videos).map((video, key) => (<span key={`video-key-${key}`}>{ video }, </span>))
                }
                {this.props.session.videos.length === 0 && <span>No videos selected</span>}
            </div>

                <div className=" suggestedExcersizes" style={{ 'overflowY': 'scroll', 'zIndex': 0,  'maxHeight': '50vh', 'position': 'relative' }}>
                  <h6>Suggested Exercises</h6>
                  {this.state.selectVideosOpen && <div>
                    <div className="search-box__content">
            <div className="search-box__input">
                <SearchIcon />
                <input type="search" onChange={this.onSearchChange} value={this.state.search} placeholder="Search for an exercise" />
            </div>
          </div><a className="link right"
                    style={{ 'zIndex': 2, 'position': 'relative' }}
                    onClick={this.toggleSelectVideosOpen}>
                    <img alt="Close" className="close"
                      src={closeImage} />
                  </a>
                  </div>
                  }
                <div className={'add-video ' + (this.props.selectVideosOpen && 'open')}
                onClick={this.toggleSelectVideosOpen}>
                <span>+</span>
              </div>                        
          
              <SelectVideos
                videos={this.videos()}
                handleToggleSelectedSessionVideo={this.props.handleToggleSelectedSessionVideo}
                playVideo={this.playVideo}
                class={this.state.selectVideosOpen && 'open'}
                available_videos={this.props.selected_areas_videos
                  .filter(videoId => Object.keys(this.props.patientRecord.videosCount).indexOf(videoId) === -1)}
                selected_videos={this.props.session.videos} />
              <br />

              {this.state.selectVideosOpen && <b className="padding md-subhead">Previously done exercises</b>}
              <div className="videos-done">
                <SelectVideos
                  videos={this.props.videos}
                  handleToggleSelectedSessionVideo={this.props.handleToggleSelectedSessionVideo}
                  videosCount={this.props.patientRecord.videosCount}
                  playVideo={this.playVideo}
                  class={this.state.selectVideosOpen && 'open'}
                  available_videos={this.props.selected_areas_videos
                    .filter(videoId => Object.keys(this.props.patientRecord.videosCount).indexOf(videoId) !== -1)}
                  selected_videos={this.props.session.videos} />
              </div>
              </div>
        </div> 
        {/* {<div><br />
          <FileUpload name={`session_${new Date().getTime()}`}
            path={`images/users/${this.props.User.uid}/sessions/`}
            callback={this.attachImage} />
        

        <div className="grid gallery">
          {this.props.session.images && (
            this.props.session.images.map(img => (
              <div className="image-container" key={img.thumb}>
                <img role="presentation"
                  src={this.state.uploadedImages[img.orig] || img.thumb} />
                <a className="link" onClick={() => {
                  this.deleteImage(img)
                }} >Delete</a>
              </div>))
          )}
        </div>
        <div>
          <TextareaAutosize className="md-input md-body-1 multiple"
            value={this.props.session.parent_notes}
            placeholder="Parent Notes"
            onChange={(e) => this.props.handleSessionFormChange(e, 'parent_notes')}
          />
          <br />
        </div>
        </div>} */}
        </div>
      </Swiper>

      </div>
      <div className="modal-footer">
        <a onClick={this.footerBackButton} className="">{this.state.playingVideo ? 'Close Video' : 'Back'}</a>
          {
            this.nextButton()
          }
      </div>
      {
        this.state.playingVideo && <Video 
        close={this.closeVideo} video={this.state.playingVideo} >
          <div>
            <a onClick={this.closeVideo} >Close</a><br /><br />
          </div>
        </Video>
      }
    </div >
    </div>
  }
}

NewSession.defaultProps = {
  patient: {},
  attachImage: () => { },
  removeImage: () => { },
  session: {
    therapy_areas: []
  },
  newSessionSelectVideosOpen: false
}

export default NewSession;



// WEBPACK FOOTER //
// ./src/components/therapist/NewSession.jsx